export default __webpack_public_path__ + "static/media/onboarding2.bddc3ffc.png";